import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=3348f7cb&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=3348f7cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3348f7cb",
  null
  
)

export default component.exports